const supportedActions = {
    cameras: {
        dynamicOptions: [{
                property: 'id',
                path: 'equipmentSelect.id'
            }],
        options: [{
                label: 'Take Snapshot',
                value: {
                    action: 'takeSnapshot',
                    body: {}
                }
            }, {
                label: 'Autofocus',
                value: {
                    action: 'autofocus',
                    body: {}
                }
            }]
    },
    accessControls: {
        dynamicOptions: [{
                property: 'id',
                path: 'equipmentSelect.id'
            }],
        options: [{
                label: 'Lock',
                value: {
                    action: 'lockDoor',
                    body: {}
                }
            },
            {
                label: 'Unlock',
                value: {
                    action: 'unlockDoor',
                    body: {}
                }
            },
            {
                label: 'Block',
                value: {
                    action: 'blockDoor',
                    body: {}
                }
            },
            {
                label: 'Open',
                value: {
                    action: 'accessDoor',
                    body: {}
                }
            }]
    },
    speakers: {
        dynamicOptions: [{
                property: 'id',
                path: 'equipmentSelect.id'
            },
            {
                property: 'equipmentId',
                path: 'equipmentSelect.id'
            }],
        options: [
            {
                label: 'Play Clip Alarm',
                value: {
                    action: 'playClip',
                    body: {
                        actionName: 'playClip',
                        clip: 'alarm'
                    }
                }
            },
            {
                label: 'Play Clip Trespassing',
                value: {
                    action: 'playClip',
                    body: {
                        actionName: 'playClip',
                        clip: 'trespassing'
                    }
                }
            },
            {
                label: 'Stop Clip',
                value: {
                    action: 'stopClip',
                    body: {}
                }
            }
        ]
    },
    pumps: {
        dynamicOptions: [{
                property: 'id',
                path: 'equipmentSelect.id'
            },
            {
                property: 'equipmentId',
                path: 'equipmentSelect.id'
            }],
        options: [{
                label: 'On',
                value: {
                    action: 'setCloudOn',
                    body: {}
                }
            },
            {
                label: 'Off',
                value: {
                    action: 'setCloudOff',
                    body: {}
                }
            },
            {
                label: 'Local Mode',
                value: {
                    action: 'setLocal',
                    body: {}
                }
            }],
    },
    strobeSiren: {
        dynamicOptions: [{
                property: 'id',
                path: 'equipmentSelect.id'
            },
            {
                property: 'equipmentId',
                path: 'equipmentSelect.id'
            }],
        options: [{
                label: 'Blue 10 seconds',
                value: {
                    action: 'startProfile',
                    body: {
                        profile: {
                            light: {
                                colors: ['blue'],
                                intensity: 5,
                                pattern: 'Steady',
                                priority: 3,
                                speed: 1,
                                duration: {
                                    unit: 'seconds',
                                    value: 10
                                }
                            }
                        }
                    }
                }
            },
            {
                label: 'Red 10 seconds',
                value: {
                    action: 'startProfile',
                    body: {
                        profile: {
                            light: {
                                colors: ['red'],
                                intensity: 5,
                                pattern: 'Steady',
                                priority: 3,
                                speed: 1,
                                duration: {
                                    unit: 'seconds',
                                    value: 10
                                }
                            }
                        }
                    }
                }
            },
            {
                label: 'Green 10 seconds',
                value: {
                    action: 'startProfile',
                    body: {
                        profile: {
                            light: {
                                colors: ['green'],
                                intensity: 5,
                                pattern: 'Steady',
                                priority: 3,
                                speed: 1,
                                duration: {
                                    unit: 'seconds',
                                    value: 10
                                }
                            }
                        }
                    }
                }
            },
            {
                label: 'Amber 10 seconds',
                value: {
                    action: 'startProfile',
                    body: {
                        profile: {
                            light: {
                                colors: ['amber'],
                                intensity: 5,
                                pattern: 'Steady',
                                priority: 3,
                                speed: 1,
                                duration: {
                                    unit: 'seconds',
                                    value: 10
                                }
                            }
                        }
                    }
                }
            },
            {
                label: 'White 10 seconds',
                value: {
                    action: 'startProfile',
                    body: {
                        profile: {
                            light: {
                                colors: ['white'],
                                intensity: 5,
                                pattern: 'Steady',
                                priority: 3,
                                speed: 1,
                                duration: {
                                    unit: 'seconds',
                                    value: 10
                                }
                            }
                        }
                    }
                }
            },
            {
                label: 'Steady Amber 20 seconds',
                value: {
                    action: 'startProfile',
                    body: {
                        profile: {
                            light: {
                                colors: ['amber'],
                                intensity: 5,
                                pattern: 'Steady',
                                priority: 3,
                                speed: 1,
                                duration: {
                                    unit: 'seconds',
                                    value: 20
                                }
                            }
                        }
                    }
                }
            },
            {
                label: 'Alternate Red Blue 20s, Falling Pitch 10s',
                value: {
                    action: 'startProfile',
                    body: {
                        profile: {
                            siren: {
                                intensity: 4,
                                pattern: 'Siren: Falling pitch',
                                priority: 4,
                                duration: {
                                    unit: 'seconds',
                                    value: 10
                                }
                            },
                            light: {
                                colors: [
                                    'red',
                                    'blue'
                                ],
                                intensity: 5,
                                pattern: 'Alternate',
                                priority: 4,
                                speed: 3,
                                duration: {
                                    unit: 'seconds',
                                    value: 20
                                }
                            }
                        }
                    }
                }
            }],
    }
};
export default supportedActions;
